import React from 'react'
import { get } from 'lodash'
import popup from '../../popup'
import './style.css'
import { forgotPassword } from '~/redux/user/helpers';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  getVal(key){
    return get(this.props.args.fields, key)
  }

  render() {
    if (this.state.forgotPasswordSuccess)
      return (this.successScreen())

    return (
      <div className="forgot-password centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <div className="mobile-heading">{this.getVal('mobileHeaderText')}</div>
        <span className="intro"> {this.getVal('headerText')}</span>
        <div className="input-box">
          <input
            type="text"
            placeholder={this.getVal('emailInput')}
            ref={ i => { this.forgotPasswordInput = i} }
            onKeyPress={ e => {
              if (e.key === 'Enter') this.submitForgotPassword()
            } }
            />
        </div>
        <div className="error-box">{ this.state.forgotPasswordError || '' }</div>

        <button
          className={ `button cta submit-button ${ this.state.buttonProgress ? 'disabled' : '' }` }
          onClick={ e => { this.submitForgotPassword() } }>
            { this.state.buttonProgress ? '...' : this.getVal('emailPasswordCta') }
        </button>
        <div className="back-button" onClick={ e => { this.props.args ? popup.hide() : popup.login() } }> {this.getVal('backCta')} </div>
      </div>
    )
  }

  successScreen() {
    return (
      <div className="forgot-password centered">
        <span className="intro"> {this.getVal('forgotPasswordSuccess')}</span>
      </div>
    )
  }

  submitForgotPassword() {
    this.setState({...this.state, forgotPasswordError: null, buttonProgress: true })

    forgotPassword(this.forgotPasswordInput.value).then( res => {
      var emailSent = res.data && res.data.emailSent
      var error = res.data && res.data.error

      this.setState({
        ...this.state,
        forgotPasswordError: null,
        buttonProgress: false,
        forgotPasswordSuccess: emailSent
      })

      if (!emailSent)
        this.forgotPasswordAlert(
          error ? this.getVal(res.data.code) : error
        )

    }).catch( e => {
      this.setState({...this.state, buttonProgress: false })
      var message =
        this.getVal((((e || {}).response || {}).data || {}).code) ||
        this.getVal('forgotPasswordProcessError')
      this.forgotPasswordAlert(message)
    })
  }

  forgotPasswordAlert(txt) {
    this.setState({...this.state, forgotPasswordError: txt })
    setTimeout( _ => { this.setState({...this.state, forgotPasswordError: null }) }, 5000)
  }
}

export default ForgotPassword;